import { createContext, useContext, type ReactNode } from 'react';

// The screen select, handed to whatever is drawing the controls.
//
// A stage that fills the window puts its own pills in a row at the top, and the
// select belongs in that row rather than floating over it: two groups of
// controls on one line is two places to look for the same kind of thing. But the
// select is built by the route, which knows the screen's siblings, and the row
// is built by the stage, which does not. So the route puts it here and the stage
// takes it.
//
// Null on every screen that is not one of several, which is most of them: a
// stage renders nothing and its row is what it always was.
export const ScreenSelectContext = createContext<ReactNode>(null);

export const useScreenSelect = () => useContext(ScreenSelectContext);
